module.exports = __webpack_public_path__ + "static/media/trofeo4.406980bb.png";